// @flow
import React from 'react';
import { connect } from 'react-redux';

import type { TEMPORARY_EVENT_TYPE } from '../../types/temporaryEvents';
import * as selectors from '../../reducers';
import FlashMessage from './FlashMessage';

import styles from './flashMessages.css';


type FlashMessagesPropTypes = {
  events: Array<TEMPORARY_EVENT_TYPE>,
};

const FlashMessages = ({
  events = [],
}: FlashMessagesPropTypes) => (
  events.length > 0 ? (
    <div className={styles.flashMessages}>
      {
        events.map(
          event => (
            <FlashMessage
              key={event.id}
              {...event}
              {...event.data}
            />
          ),
        )
      }
    </div>
  ) : null
);

export default connect(
  state => ({
    events: selectors.getTemporaryEventsByGroup(state, 'flashMessages'),
  }),
  undefined,
)(FlashMessages);



// WEBPACK FOOTER //
// ./src/scripts/components/FlashMessages/index.jsx